import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightText'
})
export class HighlightTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  // transform(text: string, search: string): any {
  //   if (!search) return text;
  //   const pattern = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // escape special chars
  //   const regex = new RegExp(`(${search})`, 'gi');
  //   return text?.replace(regex, `<mark>$1</mark>`);
  // }
  transform(text: string, search: string): SafeHtml {
    if (!search || !text) return text;

    const escapedSearch = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const regex = new RegExp(`(${escapedSearch})`, 'gi');

    const result = text.replace(regex, `<span class="orgApp-text-highlight">$1</span>`);
    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
  // transform(text: string, search: string): string {
  //   if (!search || !text) return text;
  //   const pattern = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // escape special chars
  //   const regex = new RegExp(`(${pattern})`, 'gi');
  //   return text.replace(regex, `<span class="orgApp-text-highlight">$1</span>`);
  // }

}
